"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true,
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("../Styles/Loader.styles.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Loader = function Loader() {
  return /*#__PURE__*/ _react.default.createElement(
    "div",
    {
      className: "loaderWrapper",
    },
    /*#__PURE__*/ _react.default.createElement(
      "figure",
      null,
      /*#__PURE__*/ _react.default.createElement("span", null),
      /*#__PURE__*/ _react.default.createElement("span", null),
      /*#__PURE__*/ _react.default.createElement("span", null),
      /*#__PURE__*/ _react.default.createElement("span", null),
      /*#__PURE__*/ _react.default.createElement("span", null),
      /*#__PURE__*/ _react.default.createElement("span", null)
    )
  );
};

var _default = Loader;
exports.default = _default;
